import React, {Component} from 'react';
import '../App.css';
import axios from 'axios';

class ResetPwd extends Component{
    //call the constructor method
    constructor(props){
        super(props);
        
        this.state = {
            new_password : "",
            new_confirm_password : "",
            message: ""
        }
        
        this.newPasswordChangeHandler = this.newPasswordChangeHandler.bind(this);
        this.newConfirmPasswordChangeHandler = this.newConfirmPasswordChangeHandler.bind(this);
        this.submitResetPwd = this.submitResetPwd.bind(this);
    }
    
    componentWillMount(){
        this.setState({
            authFlag : false
        })
    }
    

    newPasswordChangeHandler = (e) => {
        this.setState({
            new_password : e.target.value
        })
    }

    newConfirmPasswordChangeHandler = (e) => {
        this.setState({
            new_confirm_password : e.target.value
        })
    }

    handleValidation(){
        let formIsValid = true;

        if ( this.state.new_password !== this.state.new_confirm_password ) {
            formIsValid = false;
            this.setState({
                message : "The password is not matching."
            });
        }

        if(!this.state.new_confirm_password){
            formIsValid = false;
            this.setState({
                message : "Confirm Password is a Required field."
            });
        }

        //Password
        if(!this.state.new_password){
            formIsValid = false;
            this.setState({
                message : "New password is a Required field."
            });
        }
        
        return formIsValid;
   }
    //submit Login handler to send a request to the node backend
    submitResetPwd = (e) => {
        e.preventDefault();

        if(this.handleValidation()){
            const pwddata = {
                reset_pwd_code : window.location.search,
                new_password : this.state.new_password
            }
            
            axios.defaults.withCredentials = true;
            
            axios.post(window.$backend_url + '/ResetPwd',pwddata)
                .then(response => {
                    if(response.status === 200){
                        this.setState({
                            message : "Changed your password."
                        });
                        this.props.closeResetPwdPopup();
                    } else {
                        this.setState({
                            message : "Change password is failed."
                        });
                    }
                })
                .catch(error => {                    
                })
        }
    }

    switchPopupLogin = (e) => {
        e.preventDefault();
        this.props.switchPopupLogin();
    }

    render(){
        return(            
            <div className="modal-reset-pwd custom-modal">
                <div className="modal-logo">
                    <img alt="logo" src="/assets/images/logo.png" />
                </div>
                <h2 className="text-center">Change Password</h2>
                <form className="reset-pwd-form">
                    { this.state.message ?
                        <p className="message-text">{ this.state.message }</p>
                    : null }
                    <div className="form-group">
                        <label>New Password</label>
                        <div className="pwd-container ">
                            <input onChange = {this.newPasswordChangeHandler} type="password" className="form-control password" name="new_password" ></input>                            
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Confirm New Password</label>
                        <div className="pwd-container ">
                            <input onChange = {this.newConfirmPasswordChangeHandler} type="password" className="form-control password" name="new_password" ></input>                            
                        </div>
                    </div>
                    <button onClick = {this.submitResetPwd} type="submit" className="btn-submit">CHANGE PASSWORD</button>                     
                </form>
                <div className="text-center">
                    <span className="other-link">Already have an account? <a href="" className="link-yellow" onClick={this.switchPopupLogin}>Log in</a></span>
                </div>
            </div>
        )
    }
}

export default ResetPwd;


// WEBPACK FOOTER //
// ./src/components/ResetPwd.js